/**
 * @generated SignedSource<<0ffa5c8a5f68bc4537f010427d5ce4ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useNetworkSideNavUserData$data = {
  readonly userSideNavSettings: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null;
        readonly visible: boolean | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useNetworkSideNavUserData";
};
export type useNetworkSideNavUserData$key = {
  readonly " $data"?: useNetworkSideNavUserData$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNetworkSideNavUserData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityAriUserSideNavSettings"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "useNetworkSideNavUserData",
  "selections": [
    {
      "alias": "userSideNavSettings",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "entityAriUserSideNavSettings"
        },
        {
          "kind": "Variable",
          "name": "ownerAri",
          "variableName": "ownerAri"
        }
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItemConnection",
          "kind": "LinkedField",
          "name": "sidebar",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsMenuItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "menuId"
                },
                {
                  "kind": "ScalarField",
                  "name": "visible"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "SettingsDisplayPropertyConnection",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsDisplayProperty",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "48a417a1d2876624970df89dfa84bb10";

export default node;
